@if (!idle.locked() && idle.secondesRestantes() > 0) {
    <div aria-live="polite" class="fixed bottom-6 left-1/2 z-[10000] w-full max-w-md -translate-x-1/2 px-4" role="status">
        <div class="flex items-center gap-3 rounded-2xl bg-white p-4 shadow-2xl ring-1 ring-gray-200">
            <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-dgpe-warning-500/10 text-dgpe-warning-500">
                <mat-icon class="!h-5 !w-5 !text-[20px] !leading-none">schedule</mat-icon>
            </div>
            <div class="min-w-0 flex-1">
                <p class="text-sm font-semibold text-gray-900">Verrouillage dans {{ idle.secondesRestantes() }} s</p>
                <p class="text-xs text-gray-500">Sans activité, l'écran sera masqué et votre mot de passe redemandé.</p>
            </div>
            <app-button icon="check" label="Je suis là" size="sm" variant="primary" (clicked)="resterConnecte()" />
        </div>
    </div>
}

@if (idle.locked()) {
    <div class="fixed inset-0 z-[10000] flex items-center justify-center bg-gray-900/30 p-4 backdrop-blur-md">
        <div class="w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl">
            <div class="flex flex-col items-center text-center">
                <div class="flex h-14 w-14 items-center justify-center rounded-full bg-dgpe-primary-500/10 text-dgpe-primary-500">
                    <mat-icon class="!h-7 !w-7 !text-[28px] !leading-none">lock</mat-icon>
                </div>
                <h2 class="mt-4 text-lg font-semibold text-gray-900">Session verrouillée</h2>
                <p class="mt-1 text-sm text-gray-500">Inactivité détectée. Saisissez votre mot de passe pour reprendre votre travail.</p>
                @if (user(); as u) {
                    <p class="mt-3 text-md font-medium text-gray-800">{{ u.first_name }} {{ u.last_name }}</p>
                    <p class="text-xs text-gray-500">{{ u.email }}</p>
                }
            </div>

            <form class="mt-5 space-y-3" (ngSubmit)="submit()">
                <mat-form-field class="w-full">
                    <mat-label>Mot de passe</mat-label>
                    <input
                        autocomplete="current-password"
                        matInput
                        name="lockPassword"
                        [ngModel]="password()"
                        [type]="showPassword() ? 'text' : 'password'"
                        (ngModelChange)="password.set($event)" />
                    <button mat-icon-button matSuffix type="button" (click)="showPassword.set(!showPassword())">
                        <mat-icon>{{ showPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                </mat-form-field>

                @if (error()) {
                    <p class="text-xs text-red-600">{{ error() }}</p>
                }

                <app-button
                    icon="lock_open"
                    label="Déverrouiller"
                    type="submit"
                    variant="primary"
                    [disabled]="!password().trim()"
                    [fullWidth]="true"
                    [loading]="loading()" />
            </form>

            <button
                class="mt-4 w-full rounded-lg py-2 text-center text-sm text-gray-500 transition-colors hover:bg-red-50 hover:text-red-600 active:bg-red-100"
                type="button"
                (click)="logout()">
                Se déconnecter
            </button>
        </div>
    </div>
}
